export class TribunaleDTO {
    codiceFiscale: string;
    nomeUfficio: string;
    altroNome: string;
    indirizzo: string;
    comune: string;
    codiceistat: string;
    cap: string;
    email: string;
    telefono: string;
    fax: string;
    pec: Array<string>;
    codiceCatastale: string;
    siglaProvincia: string;
    id: string;
}